import { FC, useState } from 'react';
import styled from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

interface IProps {
    total: number;
    step: number;
}

const FormStep: FC<IProps> = ({ total, step }) => {
    const { t } = useLang('membersday.return.tradein');
    const list = Array.from({ length: total }, (_item, index) => index + 1);

    return (
        <div className={styled.FormStep}>
            {list.map((item, index) => (
                <div key={item} className={`step_item ${index < step && 'active'}`}>
                    {index > 0 && <div className="line"></div>}
                    <div className="block">
                        {t('step')} {item}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default FormStep;
